class MainProductSystemConfiguration extends HTMLElement {
  constructor() {
    super();
    this.cartDrawer = document.querySelector("cart-drawer");
    this.cartCountBubble = document.querySelector("#cart-icon-bubble");
    this.boundConfigItemsEventHandler = this.configItemsEventHandler.bind(this);
  }

  connectedCallback() {
    this.systemConfigItemsContainer = this.querySelector("#system-option-list");
    this.addToCartBtn = this.querySelector(
      "#main-product-system-configuration--add-to-cart"
    );

    this.sizeError = this.querySelector(
      `#main-product-system-configuration--size-error`
    );

    this.systemConfigItemsContainer.addEventListener(
      "click",
      this.boundConfigItemsEventHandler
    );

    this.addToCartBtn.addEventListener(
      "click",
      this.addToCartBtnHandler.bind(this)
    );
    this.setSystemPrice();
  }

  disconnectedCallback() {
    this.systemConfigItemsContainer.removeEventListener(
      "click",
      this.boundConfigItemsEventHandler
    );
  }

  configItemsEventHandler(event) {
    const systemConfigItem = event.target.closest("button.system-option");
    if (!systemConfigItem) return;

    this.toggleSizeSelectors(systemConfigItem);
    this.toggleActiveSizeSelector(systemConfigItem);
    this.setSystemPrice();
    this.setProductSaleTag();
  }

  toggleActiveSizeSelector(systemConfigItem) {
    let prevActiveItem = this.querySelector(`.system-option.active`);
    prevActiveItem.classList.remove("active");
    prevActiveItem.setAttribute("aria-selected", "false");
    systemConfigItem.classList.add("active");
    systemConfigItem.setAttribute("aria-selected", "true");

    let prevActivePanel = this.querySelector(`.system-panel:not(.dawn-hidden)`);
    prevActivePanel?.classList.add("dawn-hidden");
    let nextActivePanel = this.querySelector(
      `.system-panel[data-system-handle="${systemConfigItem.dataset.systemHandle}"]`
    );
    nextActivePanel?.classList.remove("dawn-hidden");
  }

  toggleSizeSelectors(systemConfigItem) {
    systemConfigItem = systemConfigItem
      ? systemConfigItem
      : this.systemConfigItemsContainer.querySelector("button.system-option");
    this.querySelectorAll(`product-system-size-selector`).forEach((el) => {
      el.classList.add("dawn-hidden");
      el.querySelectorAll(`input[type="radio"]`).forEach(
        (input) => (input.checked = false)
      );
    });

    let selectedItemSizes = this.querySelector(
      `product-system-size-selector[data-system-handle="${systemConfigItem.dataset.systemHandle}"]`
    );
    selectedItemSizes?.classList.remove("dawn-hidden");
  }

  setSystemPrice() {
    let activePanel = this.querySelector(`.system-panel:not(.dawn-hidden)`);
    let price = activePanel?.querySelector(
      ".system-configuration-item--price"
    )?.innerHTML;
    if (!price) return;
    this.addToCartBtn.innerHTML = `<span>Add To Cart - </span> ${price}`;
  }

  setProductSaleTag() {
    const productSaleTag = this.closest(
      ".product__info-container"
    ).querySelector(`.product-sale-tag`);
    const activeTab = this.querySelector(`.system-option.active`);
    if (!productSaleTag || !activeTab) return;
    const saleTag = activeTab.dataset.saleTag;
    if (!saleTag) return;
    productSaleTag.innerText = saleTag;
  }

  addToCartBtnHandler(event) {
    let btn = event.target.closest(
      "#main-product-system-configuration--add-to-cart"
    );
    if (!btn) return;

    let variant = this.querySelector(
      `product-system-size-selector:not(.dawn-hidden) input[type="radio"]:checked`
    )?.value;

    if (!variant) {
      this.setErrorSizeErrorMessage(true);
      return;
    }

    const isSystemBundleItemSelected = this.querySelector(
      ".system-option.system-bundle-item.active"
    );

    if (isSystemBundleItemSelected) {
      this.systemBundleController();
      return;
    }

    let cartData = {
      items: [
        {
          id: variant,
          quantity: 1,
        },
      ],
    };
    this.addToCart(cartData);
  }

  systemBundleController() {
    const bundleItem = this.querySelector(
      ".system-option.system-bundle-item.active"
    );
    let { bundleProductsSettings, bundleHandle } = bundleItem.dataset;

    let size = this.querySelector(
      `product-system-size-selector:not(.dawn-hidden) input[type="radio"]:checked`
    ).value;
    let sizeOptions = size.includes("-") ? size.split("-") : false;

    let itemsForCart = bundleProductsSettings.split(":::").map((item) => {
      let [_, variantOptions] = item.split("=");

      // Check if this is the body pillow cover that needs special handling
      let isBodyPillowCover = _.includes(
        "extra-case-for-therapeutic-body-pillow-gray"
      );

      let selected_option = variantOptions.split(",").find((option) => {
        // Override: Always select medium-large for body pillow cover for shoulder gray case bundle
        if (
          isBodyPillowCover &&
          bundleHandle == "deluxe-gray-shoulder-system"
        ) {
          return option.includes("medium-large");
        }

        // Original logic for other products
        if (sizeOptions) {
          return option.includes(sizeOptions[0] || sizeOptions[1]);
        } else {
          return option.includes(size);
        }
      });

      if (!selected_option) return;
      let [__, id] = selected_option.split("::");
      return {
        id,
        quantity: 1,
        properties: {
          _bundle_handle: bundleHandle,
        },
      };
    });

    let cartData = {
      items: itemsForCart,
    };

    this.addToCart(cartData);
  }

  async addToCart(cartData) {
    this.setLoadingToAddToCart(true);
    try {
      const addResponse = await fetch(
        window.Shopify.routes.root + "cart/add.js",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(cartData),
        }
      );
      const data = await addResponse.json();
      if (!addResponse.ok) throw new Error(`${data.description}`);
      if (window._learnq) {
        // Same { id, quantity } payload the theme's other product forms send;
        // one event per cart line so bundles report every added variant.
        cartData.items.forEach(({ id, quantity }) => {
          window._learnq.push(["track", "Added to Cart", { id, quantity }]);
        });
      }
    } catch (error) {
      console.log(`${error}`);
    } finally {
      this.setLoadingToAddToCart(false);
      this.openAndPopulateCart();
      // Keep the size grid in step with the tab that is still active; the
      // no-argument form falls back to the first system.
      this.toggleSizeSelectors(this.querySelector(".system-option.active"));
      this.querySelectorAll("product-system-size-selector").forEach((el) =>
        el.resetToDefaultValue()
      );
    }
  }

  setLoadingToAddToCart(flag) {
    this.addToCartBtn.disabled = flag;
    this.addToCartBtn.ariaDisabled = flag;
    flag
      ? (this.addToCartBtn.innerHTML = "<span>Adding to cart </span>")
      : this.setSystemPrice();
  }

  async openAndPopulateCart() {
    // Fetch the updated cart drawer content from the server
    const response = await fetch("/cart");
    const responseText = await response.text();

    // Parse the fetched HTML response into a DOM document
    const newCartMarkup = new DOMParser().parseFromString(
      responseText,
      "text/html"
    );

    // Update cart icon bubble
    const newCartIconBubbleMarkup =
      newCartMarkup.querySelector("#cart-icon-bubble");
    this.cartCountBubble.innerHTML = newCartIconBubbleMarkup.innerHTML;

    // Remove empty class
    this.cartDrawer.classList.remove("is-empty");

    // Get new cart drawer markup
    const newCartDrawerMarkup = newCartMarkup.querySelector("#CartDrawer");

    // Replace markup
    this.cartDrawer
      .querySelector("#CartDrawer")
      .replaceWith(newCartDrawerMarkup);

    // Open cart
    this.cartDrawer.open();

    this.cartDrawer.hideInstallmentsCTA();

    if (typeof publish === "function" && window.PUB_SUB_EVENTS?.cartUpdate) {
      publish(PUB_SUB_EVENTS.cartUpdate, { source: "system-config" });
    }
  }

  setErrorSizeErrorMessage(flag = false) {
    if (flag) {
      this.sizeError.classList.remove("dawn-hidden");
      this.addToCartBtn.disabled = true;
      return;
    }
    this.sizeError.classList.add("dawn-hidden");
    this.addToCartBtn.disabled = false;
  }
}

class ProductSystemSizeSelector extends HTMLElement {
  constructor() {
    super();
    this.addToCartBtn = document.querySelector(
      "#main-product-system-configuration--add-to-cart"
    );

    this.sizeError = document.querySelector(
      `#main-product-system-configuration--size-error`
    );
    this.boundChangeHandler = this.changeHandler.bind(this);
  }

  connectedCallback() {
    this.addEventListener("change", this.boundChangeHandler);
  }

  disconnectedCallback() {
    this.removeEventListener("change", this.boundChangeHandler);
  }

  changeHandler(event) {
    if (event.target.matches('input[type="radio"]')) {
      this.setErrorSizeErrorMessage(false);
    }
  }

  resetToDefaultValue() {
    this.querySelectorAll('input[type="radio"]').forEach(
      (input) => (input.checked = false)
    );
  }

  setErrorSizeErrorMessage(flag = false) {
    if (flag) {
      this.sizeError.classList.remove("dawn-hidden");
      this.addToCartBtn.disabled = true;
      return;
    }
    this.sizeError.classList.add("dawn-hidden");
    this.addToCartBtn.disabled = false;
  }
}

customElements.define(
  "product-system-size-selector",
  ProductSystemSizeSelector
);

customElements.define(
  "main-product-system-configuration",
  MainProductSystemConfiguration
);
